import React from 'react';
import { Square, Heading, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { useParams } from 'react-router-dom';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import EnterpriseDepartmentDetailsName from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/EnterpriseDepartmentDetailsName';
import DepartmentEmployeeList from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentEmployees/DepartmentEmployeeList';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { InvoiceMethod } from 'src/types/Corp';
import { EnterpriseManageInvoiceRecipients } from 'src/components/enterprise/EnterpriseInvoiceRecipients/EnterpriseManageInvoiceRecipients';
import { SubtotalInvoiceMethod } from 'src/utilities/invoiceContact.utils';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { getHomeBreadcrumb } from 'src/constants/urls';

export default function EnterpriseDepartmentDetails(): JSX.Element {
  const { corpid: corpId, departmentId } =
    useParams<{ corpid: string; departmentId: string }>();

  const { corpData } = useAuth();
  const isInvoicingByDepartmentEnabled =
    corpData?.invoicingMethod === InvoiceMethod.MULTI_DEPARTMENT;
  return (
    <Square inset="lg">
      <PageHeader>
        <Heading variant="h1">Department Details</Heading>
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Admin home',
              ...getHomeBreadcrumb(corpId),
            },
            {
              label: 'Departments',
              href: `/corporate/enterprise/${corpId}/departments`,
              useRouterLink: true,
            },
          ]}
        />
      </PageHeader>
      <Stack y="md">
        <PageSection>
          <EnterpriseDepartmentDetailsName />
        </PageSection>
      </Stack>
      <Stack y="md">
        <PageSection>
          <DepartmentEmployeeList />
        </PageSection>
      </Stack>
      {isInvoicingByDepartmentEnabled && (
        <Stack y="md">
          <PageSection>
            <EnterpriseManageInvoiceRecipients
              subtotalMethod={SubtotalInvoiceMethod.DEPARTMENT}
              corpId={corpId as string}
              resourceId={departmentId as string}
            />
          </PageSection>
        </Stack>
      )}
    </Square>
  );
}
